export const TablesMock = {
  Table1: [
    {
      columns: [
        { label: "Container No.", key: "ContainerNo", },
        { label: "Container type", key: "Type" },
        { label: "Seal", key: "Seal" },
        { label: "Delivery mode", key: "DeliveryMode" },
        { label: "Gross weight", key: "GrossWeight" },
        { label: "Dimensions", key: "Dimension" },
        { label: "Empty gate in", key: "EmptyGateIn" },
        { label: "Empty gate out", key: "EmptyGateOut" },
      ],
      data: [],
      title: "Containers",
      key: "Containers",
    }
  ],
  tables2: [
    {
      columns: [
        // { label: 'No. Paquetes', key: 'NoContenedor'},
        { label: "Package", key: "Package" },
        { label: "Package type", key: "PackageType" },
        { label: "Weight", key: "UOMTotalWeight" },
        { label: "Volume", key: "UOMTotalVolume" },
      ],
      data: [],
      title: "Packages",
      key: "Packages",
    },
  ],
  steps: [
    {
      label: 'Carga Lista',
      value: '',
      id: 3,
      completed: false,
      order: 1,
      middleStep: ''
    },
    {
      label: 'Recolección / Recepción',
      value: '',
      id: 4,
      completed: false,
      order: 2,
      idStep: '',
      middleStep: ''
    },
    {
      label: 'ATD',
      value: '',
      id: 9,
      completed: false,
      order: 3,
      middle: false,
      idStep: '',
      middleStep: ''
    },
    {
      label: 'ATA',
      value: '',
      id: 11,
      completed: false,
      order: 4,
      idStep: 'step4',
      middleStep: ''
    },
    {
      label: 'Salida del Puerto',
      value: '',
      id: 22,
      completed: false,
      order: 5,
      idStep: 'step5',
      middleStep: ''
    },
    {
      label: 'Destino Final',
      value: '',
      id: 23,
      completed: false,
      order: 6,
      idStep: 'step6',
      middleStep: ''
    }
  ],
};
